import { render, staticRenderFns } from "./item.vue?vue&type=template&id=9c1db388&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1db388')) {
      api.createRecord('9c1db388', component.options)
    } else {
      api.reload('9c1db388', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=9c1db388&", function () {
      api.rerender('9c1db388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/u8-rank/item.vue"
export default component.exports